import { FilterCompanyAdverseMediaWebPage, getCompanyAdverseMediaWebPage } from 'commons/service/bank/companyDetails'
import { CompanyAdverseMediaWebPage } from 'commons/types/DTO/bank/companyDetails/adverseMedia'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyAdverseMediaWebPage: WriteHook<
  FilterCompanyAdverseMediaWebPage,
  CompanyAdverseMediaWebPage
> = (opts) => useMutationManager(getCompanyAdverseMediaWebPage, opts)
